"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KONTIST_API_BASE_URL = "https://api.kontist.com";